import { render, staticRenderFns } from "./DrugHandover.vue?vue&type=template&id=68e22115&scoped=true"
import script from "./DrugHandover.vue?vue&type=script&lang=js"
export * from "./DrugHandover.vue?vue&type=script&lang=js"
import style0 from "./DrugHandover.vue?vue&type=style&index=0&id=68e22115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e22115",
  null
  
)

export default component.exports